export const NAVIGATION_LINKS = [
  {
    key: 'dashboard',
    label: 'Home',
    path: '/',
    icon: {
      default: '/icons/dashboard-black.svg',
      active: '/icons/dashboard-white.svg',
    },
  },
  {
    key: 'pay',
    label: 'Pay',
    path: '/Pay',
    icon: {
      default: '/icons/pay-black.svg',
      active: '/icons/pay-white.svg',
    },
  },
  {
    key: 'beneficiaries',
    label: 'Beneficiaries',
    path: '/ListBeneficiaries',
    icon: {
      default: '/icons/beneficiaries-black.svg',
      active: '/icons/beneficiaries-white.svg',
    },
  },
  {
    key: 'transactions',
    label: 'Transactions',
    path: '/transactions',
    icon: {
      default: '/icons/transaction-black.svg',
      active: '/icons/transaction-white.svg',
    },
  },
  {
    key: 'convert',
    label: 'Convert',
    path: '/Conversions',
    icon: {
      default: '/icons/convert-black.svg',
      active: '/icons/convert-white.svg',
    },
  },
  {
    key: 'FasterPayment',
    label: 'FasterPayment',
    path: '/FasterPayment',
    icon: {
      default: '/icons/pay-black.svg',
      active: '/icons/pay-white.svg',
    },
  },
  {
    key: 'Sendmoney',
    label: 'Send Money',
    path: '/SendMoneyTab',
    icon: {
      default: '/icons/money-black.png',
      active: '/icons/money-white.png',
    },
  },
  {
    key: 'bulkupload',
    label: 'Bulk Upload',
    path: '/bulkupload',
    icon: {
      default: '/icons/builk-upload-black.svg',
      active: '/icons/builk-upload-white.svg',
    },
  },
  // {
  //   key: 'bulkupload1',
  //   label: 'Bulk Upload Senario1',
  //   path: '/BulkUploadReplica1',
  //   icon: {
  //     default: '/icons/builk-upload-black.svg',
  //     active: '/icons/builk-upload-white.svg',
  //   },
  // },
  //  {
  //   key: 'bulkupload2',
  //   label: 'Bulk Upload Senario2',
  //   path: '/BulkUploadReplica2',
  //   icon: {
  //     default: '/icons/builk-upload-black.svg',
  //     active: '/icons/builk-upload-white.svg',
  //   },
  // },

  {
    key: 'contactsupport',
    label: 'Contact support',
    path: '/contactsupport',
    icon: {
      default: '/icons/list-ticket-dark.svg',
      active: '/icons/list-ticket-white.svg',
    },
  },
  {
    key: 'logout',
    label: 'Logout',
    path: '/logout',
    icon: {
      default: '/icons/logout.svg',
      active: '/icons/logout.svg',
    },
  },
];

export const ADMIN_USER_NAVIGATION_LINKS = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    path: '/',
    icon: {
      default: '/icons/dashboard-black.svg',
      active: '/icons/dashboard-white.svg',
    },
  },
  {
    key: 'pay',
    label: 'Pay',
    path: '/Pay',
    icon: {
      default: '/icons/pay-black.svg',
      active: '/icons/pay-white.svg',
    },
  },
  {
    key: 'beneficiaries',
    label: 'Beneficiaries',
    path: '/ListBeneficiaries',
    icon: {
      default: '/icons/beneficiaries-black.svg',
      active: '/icons/beneficiaries-white.svg',
    },
  },
  {
    key: 'transactions',
    label: 'Transactions',
    path: '/transactions',
    icon: {
      default: '/icons/transaction-black.svg',
      active: '/icons/transaction-white.svg',
    },
  },
  {
    key: 'convert',
    label: 'Convert',
    path: '/Conversions',
    icon: {
      default: '/icons/convert-black.svg',
      active: '/icons/convert-white.svg',
    },
  },
  {
    key: 'Sendmoney',
    label: 'Send Money',
    path: '/SendMoneyTab',
    icon: {
      default: '/icons/money-black.png',
      active: '/icons/money-white.png',
  },
  },  {
    key: "bulkupload",
    label: "Bulk Upload",
    path: "/bulkupload",
    icon: {
      default: '/icons/builk-upload-black.svg',
      active: '/icons/builk-upload-white.svg',
    },
  },
  {
    key: 'FasterPayment',
    label: 'FasterPayment',
    path: '/FasterPayment',
    icon: {
      default: '/icons/pay-black.svg',
      active: '/icons/pay-white.svg',
    },
  },
  {
    key: 'reverttoself',
    label: 'Revert To Self',
    path: '/reverttoself',
    icon: {
      default: '/icons/undo-svgrepo-com.svg',
      active: '/icons/undo-svgrepo-com.svg',
    },
  },
];

export const ADMIN_NAVIGATION_LINKS = [
  {
    key: 'transactions',
    label: 'Debit Transactions',
    path: '/DebitTransactions',
    icon: {
      default: '/icons/debit-trans-black.svg',
      active: '/icons/debit-trans-white.svg',
    },
  },
  {
    key: 'credittransactions',
    label: 'Credit Transactions',
    path: '/CreditTransactions',
    icon: {
      default: '/icons/credit-trans-black.svg',
      active: '/icons/credit-trans-white.svg',
    },
  },
  {
    key: 'memberships',
    label: 'Memberships',
    path: '/memberships',
    icon: {
      default: '/icons/beneficiaries-black.svg',
      active: '/icons/beneficiaries-white.svg',
    },
  },
  {
    key: 'createmembership',
    label: 'Create Membership',
    path: '/createmembership',
    icon: {
      default: '/icons/beneficiaries-black.svg',
      active: '/icons/beneficiaries-white.svg',
    },
  },
  // {
  //   key: 'createbulkmembership',
  //   label: 'Create Bulk Membership',
  //   path: '/createbulkmemebership',
  //   icon: {
  //     default: '/icons/membershipcard.svg',
  //     active: '/icons/membershipcard.svg',
  //   },
  // },
  {
    key: 'logout',
    label: 'Logout',
    path: '/logout',
    icon: {
      default: '/icons/logout.svg',
      active: '/icons/logout.svg',
    },
  },
];

export const BOTTOM_LINKS = [
  // {
  //   key: "logout",
  //   label: "Logout",
  //   path: "/logout",
  //   icon: <IoIosLogOut />
  // }
];
